import { FormHelperText } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import { FormControlTypeMap } from '@mui/material/FormControl/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import Select from '@mui/material/Select'
import { BaseSelectProps } from '@mui/material/Select/Select'
import { useField } from 'formik'
import React from 'react'

interface FormikSelectFieldProps extends BaseSelectProps<any> {
  name: string
  formControlProps?: OverridableComponent<FormControlTypeMap> | any
  options: {
    label: string | number
    value: string | number
  }[]
}

const FormikSelectField: React.FC<FormikSelectFieldProps> = ({ name, formControlProps, options, ...props }) => {
  const [{ value }, { error, touched }, { setValue }] = useField(name)
  const handleChange = e => {
    setValue(e.target.value)
  }
  return (
    <FormControl variant='standard' margin='normal' fullWidth {...(formControlProps || {})}>
      {props.label && <InputLabel id={`id_select_${name}`}>{props.label}</InputLabel>}
      <Select
        name='name'
        id={`id_select_${name}`}
        value={value}
        onChange={handleChange}
        disabled={!options?.length}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          transformOrigin: { vertical: 'top', horizontal: 'right' },
          keepMounted: true,
        }}
        {...(props as any)}
      >
        {options.map(o => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </Select>
      {touched && !!error && (
        <FormHelperText variant={props.variant || 'standard'} error>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default FormikSelectField
